import AddIcon from '@mui/icons-material/Add';
import DeleteIcon from '@mui/icons-material/Delete';
import ImageIcon from '@mui/icons-material/Image';
import { Button, Grid, IconButton, TextField, Tooltip } from "@mui/material";
import Box from "@mui/material/Box";
import Divider from '@mui/material/Divider';
import React, { useRef } from "react";
import { IMajSpiderEdition } from "./interface";

interface IEddProps {
  editionMajSpider: IMajSpiderEdition;
  setEditionMajSpider: (x: IMajSpiderEdition) => void;
  selectedFile: any;
  setSelectedFile: (x: any) => void;
  arrayToEdit: any;
  setArrayToEdit: (x: any) => void;
}




const Edit = (props: IEddProps) => {

  //props
  const {
    editionMajSpider,
    setEditionMajSpider,
    selectedFile,
    setSelectedFile,
    arrayToEdit,
    setArrayToEdit
  } = props


  //hooks
  const selectPhoto: any = useRef(null);


  //fonctions
  const handleInputChange = (e: any) => {
    const { value, name } = e.target
    setEditionMajSpider({ ...editionMajSpider, [name]: value })
  }

  //ecrire dans un champ de saisie (une fonctionnalité)
  const handleFonctionnaliteChange = (event: any, index: number) => {
    const { name, value } = event.target;
    const updatedState: any = [...arrayToEdit];
    updatedState[index] = value;
    setArrayToEdit(updatedState);
  };


  //ajouter un champ de saisie (une ligne de fonctionnalité)
  const handleAddRowFonctionnalite = () => {
    const newData = [...arrayToEdit]
    setArrayToEdit([...newData, ""])
  }

  // supprimer un champ de saisie (une ligne de fonctionnalité)
  const handleFonctionnaliteRowDelete = (currentIndex: number) => {
    let newData = [...arrayToEdit]
    const res = newData.filter((item, index) => index !== currentIndex)
    setArrayToEdit(res)
  };


  return (
    <Box sx={{ flexGrow: 1, width: "100%" }}>
      <Grid
        container
        spacing={2}
        direction="row"
        justifyContent="flex-start"
        alignItems="center"
      >
        <Grid item md={12} xs={12} sm={12}>
          <TextField
            // fullWidth
            size="small"
            name="versionNumber"
            label="version"
            style={{ width: "50%" }}
            value={editionMajSpider.versionNumber}
            onChange={handleInputChange}
          />
        </Grid>

        <Grid item md={12} xs={12} sm={12}>
          <TextField
            fullWidth
            size="small"
            type="date"
            name="versionDate"
            helperText="Date de la version"
            style={{ width: "50%" }}
            value={editionMajSpider.versionDate}
            onChange={handleInputChange}
          />
        </Grid>

        <Grid item md={6} xs={12} sm={6}>
          <Grid
            container
            spacing={2}
            direction="row"
            justifyContent="flex-start"
            alignItems="center"
          >

            <Grid item md={12} xs={12} sm={12}>
              {selectedFile ? selectedFile.name : editionMajSpider?.versionFileLocation}
            </Grid>

            <Grid item md={12} xs={12} sm={12}>
              <Tooltip title="Charger l'image">
                <Button
                  variant="outlined"
                  color="primary"
                  component="label"
                  startIcon={<ImageIcon />}
                  style={{ marginTop: 10 }}
                  onClick={() => {
                    selectPhoto?.current?.click();
                  }}
                >
                  Charger le fichier exe
                </Button>
              </Tooltip>
              <input
                hidden
                multiple
                type="file"
                name="file"
                ref={selectPhoto}
                onChange={(e: any) => {
                  const files = e.target.files[0];
                  if (files) {
                    const img = URL.createObjectURL(files);
                    setSelectedFile(e.target.files[0]);
                  }
                }}
              />
            </Grid>

            <Grid item md={12} xs={12} sm={12}>
              <Divider />
            </Grid>

            {arrayToEdit?.map((item: string, index: number) => (
              <Grid key={index} item md={12} xs={12} sm={12}>
                <TextField
                  // fullWidth
                  // name="fonctionnalite"
                  style={{ width: "90%" }}
                  label="Fonctionnalité"
                  value={item}
                  onChange={(e) => handleFonctionnaliteChange(e, index)}
                />
                <Tooltip title="Supprimer">
                  <IconButton
                    onClick={() => handleFonctionnaliteRowDelete(index)}
                    style={{ marginTop: 10 }}
                  >
                    <DeleteIcon color="error" />
                  </IconButton>
                </Tooltip>
              </Grid>
            ))}

            <Grid item md={12} xs={12} sm={12}>
              <Tooltip title="Ajouter une fonctionnalité">
                <Button
                  onClick={handleAddRowFonctionnalite}
                  startIcon={<AddIcon color="primary" />}
                >
                  Ajouter une nouvelle fonctionnalité
                </Button>
              </Tooltip>
            </Grid>
          </Grid>
        </Grid>
      </Grid>
    </Box>
  );
};

export default Edit;




